// extracted by mini-css-extract-plugin
export default {"Header":"NoticesLayout_Header__pOxPQ","NavLink":"NoticesLayout_NavLink__UFhjA","NavLink__active":"NoticesLayout_NavLink__active__FSk9+","Body":"NoticesLayout_Body__ZBwya"};